import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mxToolBox = defineConnector({
  identifier: "mxToolBox",
  name: "MxToolBox",
  tagLine: "Email, DNS, and network diagnostics",
  logo,
  protocol: "http",
  tags: ["security", "data"],
  auth: (app) =>
    queryAuth([{ name: "authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your MxToolBox API key",
      items: [
        {
          kind: "markdown",
          content:
            "In MxToolBox, create or copy your API key. The API passes it as the `authorization` query parameter.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.mxtoolbox.com/api/v1/lookup/dns/?argument=example.com",
  },
  defaultUrlPattern: () => "https://api\\.mxtoolbox\\.com/.*",
});
